import { useState } from 'react';

export type InputValue = string | null;

export const useInput = (initialValue: InputValue) => {
  const [value, setValue] = useState<InputValue>(initialValue);

  const handleChange = (value: InputValue) => {
    setValue(value);
  };

  const handleReset = () => {
    setValue(null);
  };

  return {
    value,
    onChange: handleChange,
    reset: handleReset,
  };
};

export default useInput;
